import { render, staticRenderFns } from "./menuItemCardCustom.vue?vue&type=template&id=4927b687&"
import script from "./menuItemCardCustom.vue?vue&type=script&lang=js&"
export * from "./menuItemCardCustom.vue?vue&type=script&lang=js&"
import style0 from "./menuItemCardCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports